/**
 * Deterministic PRNG helper utilities for narrative generation.
 */

export function pickOne<T>(arr: readonly T[], rng: () => number): T {
  if (arr.length === 0) {
    throw new Error("Cannot pick from empty array");
  }
  const idx = Math.floor(rng() * arr.length);
  return arr[Math.min(idx, arr.length - 1)];
}

export function pickN<T>(arr: readonly T[], n: number, rng: () => number): T[] {
  const pool = [...arr];
  const count = Math.min(n, pool.length);
  const result: T[] = [];
  for (let i = 0; i < count; i++) {
    const idx = Math.floor(rng() * pool.length);
    result.push(pool.splice(idx, 1)[0]);
  }
  return result;
}

export function clamp(val: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, val));
}

export {
  fill,
  pick,
  pickDistinct,
  shuffle,
  pickWeighted,
  listJoin,
  cap,
  lower,
  ordinal,
  INTEREST_PHRASE,
  STRENGTH_PHRASE,
  AMBITION_PHRASE,
  LIFE_PATH_PHRASE,
  influenceLead,
} from "./compose";
